import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '../../shared/global';
import { EMPTY, Observable, from } from 'rxjs';
import { IPartnerRequest } from '../models/partnerrequest';
import { IPartnerResult } from '../models/partnerresult';
import { IPartner } from '../models/partner';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MaintainanceService } from './maintainance.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(private http: HttpClient, private router: Router, private maintainanceService: MaintainanceService) { }

  getVersicherungsnehmerBySearchParameter(model: IPartnerRequest, query: string): Observable<IPartnerResult> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['maintenance']);
          return EMPTY;
        } else {
          return this.http.post<IPartnerResult>(Global.BASE_PARTNER_ENDPOINT +
            `getversicherungsnehmerbysearchparameter` + (query ? `?q=${query}` : ''), body, options);
        }
      }));
  }

  getVersicherungsnehmer(model: IPartnerRequest, query: string): Observable<IPartner> {
    const body = JSON.stringify(model);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers: headers };
    return from(this.maintainanceService.deploymentInProgess()).pipe(
      switchMap(deploymentInProgress => {
        if (deploymentInProgress) {
          this.router.navigate(['maintenance']);
          return EMPTY;
        } else {
          return this.http.post<IPartner>(Global.BASE_PARTNER_ENDPOINT +
            `getversicherungsnehmer` + (query ? `?q=${query}` : ''), body, options);
        }
      }));
  }
}
